import type {PropsWithChildren} from 'react';
import React from 'react';
import clsx from 'clsx';

import {slugifyHeading} from '@/modules/finkn/shared/utils';

import {Heading} from '../typography/heading';

interface Props extends PropsWithChildren {
	heading?: string;
	anchorHeading?: boolean;
	textCenter?: boolean;
}

export const ContentBlockHeading = ({
	heading,
	children,
	anchorHeading,
	textCenter,
}: Props) => {
	if (!heading && !children) {
		return null;
	}

	const id = heading && anchorHeading ? slugifyHeading(heading) : undefined;

	return (
		<div className={clsx(textCenter && 'text-center', 'mb-6', 'md:mb-10')}>
			{heading && (
				<Heading
					level={2}
					spacing
					size="lg"
					className={clsx(anchorHeading && 'scroll-m-32')}
					{...(id ? {id} : {})}
				>
					{heading}
				</Heading>
			)}
			{children && (
				<div
					className={clsx(
						'text-grey-15',
						'max-w-[800px]',
						textCenter && 'mx-auto',
					)}
				>
					{children}
				</div>
			)}
		</div>
	);
};
